import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getProductByID } from "../services/ProductService";
import Minus from "../static/Product/minus.svg";
import Plus from "../static/Product/plus.svg";
import Cart from "../static/Product/cart.svg";
import Accordion from "react-bootstrap/Accordion";
import parse from "html-react-parser";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useDispatch, useSelector } from "react-redux";
import { addTOCart } from "../redux/cartSlice";
import { showAlert, hideAlert } from "../redux/alertSlice";
import { getLocalData } from "../utils/localStorage";

import { addToCart, getCartItems } from "../services/CartService";
import NoImage from "../static/noimagegray.svg";
import Wishlist from "../components/SvgComponents/Wishlist";

function ProductDetails() {
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const [imageGallery, setImageGallery] = useState([]);

  const defaultImage = [
    {
      original: NoImage,

      thumbnail: NoImage,
    },
  ];

  const handleQuantityIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleQuantityDecrement = () => {
    setQuantity(quantity - 1);
  };

  const { id } = useParams();

  const dispatch = useDispatch();

  const outletIdM = getLocalData('outlet-id')
  

  useEffect(() => {
    getProductByID(id,outletIdM).then(
      (res) => {

        console.log(res)
        setProduct(res);

        let tempMediaGallery = [];


        res.mediaPictures.forEach(picture => {
          let tempVar = {
            original: picture.pictureUrl,
            thumbnail: picture.pictureUrl,
          };
          tempMediaGallery.push(tempVar);
        });
       
        setImageGallery(tempMediaGallery);
      },
      (failure) => {
        console.error(failure); //expected output: Oopsy...
      }
    );
  }, [id,outletIdM]);

  //userinfo
  const userData = useSelector((state) => state.user.userData);

  //currency
  const currency = useSelector((state) => state.pharmacy.currencySymbol);

  //wishlist functionality
  const allAssociatedProducts = useSelector((state) => state.cart.cartItems);

  const handleClickOnWishlist = (id) => {
    if (JSON.stringify(userData) !== "{}") {
      const isProductPresentInWishList = allAssociatedProducts.find(
        (o) => o.productId === parseInt(id) && o.shoppingCartTypeId === 2
      );

      dispatch(hideAlert());

      let tempProduct = {
        productId: parseInt(product.id),
        quantity: 1,
        shoppingCartTypeId: 2,
      };

      if (!isProductPresentInWishList) {
        let tempArrForAddTOCart = [];


        
        allAssociatedProducts.forEach((item) => {
          let tempItem = {
            productId: item.productId,
            quantity: item.quantity,
            shoppingCartTypeId: item.shoppingCartTypeId,
          };

          tempArrForAddTOCart.push(tempItem);
        });

        tempArrForAddTOCart.push(tempProduct);

        console.log("jhgjhg",userData.outletId)
        addToCart(
          getLocalData("user-info")?.userData.id,
         outletIdM,
          getLocalData("user-info")?.userToken,
          tempArrForAddTOCart
        )
          .then((data) => {
            console.log(data);
            if (data === "Success") {
              getCartItems(getLocalData("user-info")?.userToken).then(
                (res) => {
                  dispatch(addTOCart(res));
                },
                (failure) => {
                  console.error(failure); //expected output: Oopsy...
                }
              );
            }
          })
          .catch((err) => console.log(err));
        let alert = {
          state: "success",
          msg: `${product.name} Added to Wishlist`,
        };
        dispatch(showAlert(alert));
      } else {
        let alert = {
          state: "danger",
          msg: `${product.name} is already in Wishlist`,
        };
        dispatch(showAlert(alert));
      }
    } else if (JSON.stringify(userData) === "{}") {
      let alert = {
        state: "danger",
        msg: `Please Login/Sign-Up to Continue`,
      };
      dispatch(showAlert(alert));
    }
  };

  const handleClickOnAddTOCart = (id) => {
    if (JSON.stringify(userData) !== "{}") {
      const isProductPresentInWishList = allAssociatedProducts.find(
        (o) => o.productId === parseInt(id) && o.shoppingCartTypeId === 1
      );

      dispatch(hideAlert());

      let tempProduct = {
        productId: parseInt(product.id),
        quantity: quantity,
        shoppingCartTypeId: 1,
      };

      if (!isProductPresentInWishList) {
        let tempArrForAddTOCart = [];

        allAssociatedProducts.forEach((item) => {
          let tempItem = {
            productId: item.productId,
            quantity: item.quantity,
            shoppingCartTypeId: item.shoppingCartTypeId,
          };

          tempArrForAddTOCart.push(tempItem);
        });

        tempArrForAddTOCart.push(tempProduct);

        addToCart(
          getLocalData("user-info")?.userData.id,
         outletIdM,
          getLocalData("user-info")?.userToken,
          tempArrForAddTOCart
        )
          .then((data) => {
            console.log(data);
            if (data === "Success") {
              getCartItems(getLocalData("user-info")?.userToken).then(
                (res) => {
                  dispatch(addTOCart(res));
                },
                (failure) => {
                  console.error(failure); //expected output: Oopsy...
                }
              );
            }
          })
          .catch((err) => console.log(err));
        let alert = {
          state: "success",
          msg: `${product.name} Added to Cart`,
        };
        dispatch(showAlert(alert));
      } else {
        let tempArrForAddTOCart = [];

        allAssociatedProducts.forEach((item) => {
          let tempItem = {
            productId: item.productId,
            quantity: item.quantity,
            shoppingCartTypeId: item.shoppingCartTypeId,
          };

          if (item.productId == tempProduct.productId) {
            tempItem.quantity = tempItem.quantity + tempProduct.quantity;
          }
          tempArrForAddTOCart.push(tempItem);
        });

        addToCart(
          getLocalData("user-info")?.userData.id,
         outletIdM,
          getLocalData("user-info")?.userToken,
          tempArrForAddTOCart
        )
          .then((data) => {
            
            if (data === "Success") {
              getCartItems(getLocalData("user-info")?.userToken).then(
                (res) => {
                  dispatch(addTOCart(res));
                },
                (failure) => {
                  console.error(failure); //expected output: Oopsy...
                }
              );
            }
          })
          .catch((err) => console.log(err));
        let alert = {
          state: "success",
          msg: `${product.name} Added to Cart`,
        };
        dispatch(showAlert(alert));
      }
    } else if (JSON.stringify(userData) === "{}") {
      let alert = {
        state: "danger",
        msg: `Please Login/Sign-Up to Continue`,
      };
      dispatch(showAlert(alert));
    }
  };

  console.log(product)
  return (
    product && (
      <section className="space-at-top">
        <div className="container">
          <Row className="pb-2">
            <Col md={4}></Col>
          </Row>
          <Row>
            <Col md={5} className="">
              {imageGallery[0].original !== "" ? (
                <ImageGallery
                  items={imageGallery}
                  showBullets={true}
                  showFullscreenButton={false}
                  showPlayButton={false}
                />
              ) : (
                <ImageGallery
                  items={defaultImage}
                  showBullets={true}
                  showFullscreenButton={false}
                  showPlayButton={false}
                />
              )}
            </Col>
            <Col md={7}>
              <Row>
                <Col md={12}>
                  <span className="pd-name">{product.name}</span>
                </Col>
                <Col md={12}>
                  <span className="pd-manufacturer-name">
                    {
                      product.manufacturerName !== '' && (
                        `by ${product.manufacturerName} `
                      )
                    }
                   
                  </span>
                </Col>
                {
                  product.drugTypeValue === 'PrescriptionDrug' && (
                    <Col md={12}>
                  <span className="pd-type"> Prescription Required</span>
                </Col>
                  )
                }
                
                <Col md={12}>
                  <span className="pd-price">{currency}  {product.price}</span>
                </Col>
                <Col md={12}>
                  {product.oldPrice && (
                    <>
                      <span className="pd-old-price">{currency}  {product.oldPrice}</span>
                      <span className="pd-disc">
                        {`${
                          (100 - (product.price / product.oldPrice) * 100)
                            .toString()
                            .match(/^-?\d+(?:\.\d{0,2})?/)[0]
                        }%`}
                        OFF
                      </span>
                    </>
                  )}
                </Col>
                {
                    product.stockQuantity > 0 && (
                      <Col md={12}>
                  
                      <span className="pd-quantity-header">Quantity</span>
                      <div className="pd-cart-button-grp">
                        <button
                          className="btn btn-secondary"
                          disabled={quantity === 1 ? "disabled" : ""}
                          onClick={() => {
                            handleQuantityDecrement();
                          }}
                        >
                          <img src={Minus} alt="minus" />
                        </button>
                        <span>{quantity}</span>
                        <button
                          className="btn btn-secondary"
                          disabled={quantity === 100 ? "disabled" : ""}
                          onClick={() => {
                            handleQuantityIncrement();
                          }}
                        >
                          <img src={Plus} alt="plus" />
                        </button>
                      </div>
                    </Col>
                    )

                  }
               

                <Col md={12}>
                  <Row>
                    <Col md={6}>
                      {
                        product.stockQuantity >0 ? (<button
                          className="btn pd-btn pd-atc"
                          onClick={() => {
                            handleClickOnAddTOCart(product.id);
                          }}
                        >
                          <img src={Cart} alt="cart" />
                          ADD TO CART
                        </button>) : (<button
                        className="btn pd-btn pd-atc"
                        
                      >
                        OUT OF STOCK
                      </button>)
                      }
                      
                    </Col>
                    <Col md={6}>
                      <button
                        className="btn  pd-btn "
                        onClick={() => {
                          handleClickOnWishlist(product.id);
                        }}
                      >
                        <Wishlist/>
                        ADD TO WISHLIST
                      </button>
                    </Col>
                  </Row>
                </Col>

                <Col md={12} className="pd-accordians">
           
                  <Accordion defaultActiveKey={["0"]} alwaysOpen>
                    
                    <Accordion.Item eventKey="0">
                     
                      {
                     ( product.therapeuticName  ||
                      product.genericName  ||
                      product.fullDescription) &&  (
                        <>
                        <Accordion.Header>
                        <span>
                          <span className="pd-accordian-h">Description</span>
                          <span className="pd-accordian-sh">
                            {product.therapeuticName}{" "}
                            {product.therapeuticName && product.genericName && (
                              <span className="dot"> </span>
                            )}{" "}
                            {product.genericName}
                          </span>
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        {product.fullDescription &&
                          parse(product.fullDescription)}
                      </Accordion.Body>
                        </>
                      )
                    }
                    
                    </Accordion.Item>
                    {
                      (product.adultDosage  || product.childrenDosage || product.indication  || product.contraIndication  ||  product.availabiltyPackage  ||  product.storageCondition) && (
                        <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        Storage, dosage & Indication
                      </Accordion.Header>
                      <Accordion.Body>
                        {product.adultDosage && (
                          <div className="accordian-body">
                            <span className="pd-abh">Adults</span>
                            <span className="pd-abt">
                              {product.adultDosage}
                            </span>
                          </div>
                        )}

                        {product.childrenDosage && (
                          <div className="accordian-body">
                            <span className="pd-abh">Children</span>
                            <span className="pd-abt">
                              {product.childrenDosage}
                            </span>
                          </div>
                        )}

                        {product.indication && (
                          <div className="accordian-body">
                            <span className="pd-abh">Indication</span>
                            <span className="pd-abt">{product.indication}</span>
                          </div>
                        )}

                        {product.contraIndication && (
                          <div className="accordian-body">
                            <span className="pd-abh">Contra Indication</span>
                            <span className="pd-abt">
                              {product.contraIndication}
                            </span>
                          </div>
                        )}

                        {product.availabiltyPackage && (
                          <div className="accordian-body">
                            <span className="pd-abh">Availabilty Package</span>
                            <span className="pd-abt">
                              {product.availabiltyPackage}
                            </span>
                          </div>
                        )}

                        {product.storageCondition && (
                          <div className="accordian-body">
                            <span className="pd-abh">Storage Condition</span>
                            <span className="pd-abt">
                              {product.storageCondition}
                            </span>
                          </div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                      )}
                    
                    {
                      (product.cautions  || 
                      product.sideEffectsOrAdverseEffects  || 
                      product.precautionOrWarning  || 
                      product.symptomsAndOverdoseTreatment  || 
                      product.drugInteractions) && (
                        <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        Side effects, precautions & warning
                      </Accordion.Header>
                      <Accordion.Body>
                        {product.cautions && (
                          <div className="accordian-body">
                            <span className="pd-abh">Cautions</span>
                            <span className="pd-abt">{product.cautions}</span>
                          </div>
                        )}

                        {product.sideEffectsOrAdverseEffects && (
                          <div className="accordian-body">
                            <span className="pd-abh">
                              Side Effects Or Adverse Effects
                            </span>
                            <span className="pd-abt">
                              {product.sideEffectsOrAdverseEffects}
                            </span>
                          </div>
                        )}

                        {product.precautionOrWarning && (
                          <div className="accordian-body">
                            <span className="pd-abh">
                              Precaution Or Warning
                            </span>
                            <span className="pd-abt">
                              {product.precautionOrWarning}
                            </span>
                          </div>
                        )}

                        {product.symptomsAndOverdoseTreatment && (
                          <div className="accordian-body">
                            <span className="pd-abh">
                              Symptoms And Overdose Treatment
                            </span>
                            <span className="pd-abt">
                              {product.symptomsAndOverdoseTreatment}
                            </span>
                          </div>
                        )}

                        {product.drugInteractions && (
                          <div className="accordian-body">
                            <span className="pd-abh">Drug Interactions</span>
                            <span className="pd-abt">
                              {product.drugInteractions}
                            </span>
                          </div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                      )
                    }
                    {
                      (product.pregnancyAlert  ||
                      product.lactationAlert  ||
                      product.drivingAlert  ||
                      product.liverAlert  ||
                      product.kidneyAlert) && (
                        <Accordion.Item eventKey="3">
                        <Accordion.Header>
                          Drug interactions & alerts
                        </Accordion.Header>
                        <Accordion.Body>
                          {product.pregnancyAlert && (
                            <div className="accordian-body">
                              <span className="pd-abh">Pregnancy Alert</span>
                              <span className="pd-abt">
                                {product.pregnancyAlert}
                              </span>
                            </div>
                          )}
  
                          {product.lactationAlert && (
                            <div className="accordian-body">
                              <span className="pd-abh">Lactation Alert</span>
                              <span className="pd-abt">
                                {product.lactationAlert}
                              </span>
                            </div>
                          )}
  
                          {product.drivingAlert && (
                            <div className="accordian-body">
                              <span className="pd-abh">Driving Alert</span>
                              <span className="pd-abt">
                                {product.drivingAlert}
                              </span>
                            </div>
                          )}
  
                          {product.liverAlert && (
                            <div className="accordian-body">
                              <span className="pd-abh">Liver Alert</span>
                              <span className="pd-abt">{product.liverAlert}</span>
                            </div>
                          )}
  
                          {product.kidneyAlert && (
                            <div className="accordian-body">
                              <span className="pd-abh">Kidney Alert</span>
                              <span className="pd-abt">
                                {product.kidneyAlert}
                              </span>
                            </div>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                      )
                    }
                    
                  </Accordion>
                </Col>
                <Col md={12}></Col>
                <Col md={12}></Col>
              </Row>
            </Col>
          </Row>
        </div>
      </section>
    )
  );
}

export default ProductDetails;
